// extracted by mini-css-extract-plugin
module.exports = {"colour":"Colour_colour__1TV0h"};